export default __webpack_public_path__ + "static/media/logo.d25ca395.svg";